import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class2, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import TableTraits from "./Table/TableTraits";
import UrlTraits from "./UrlTraits";
export let ObservablePropertyTraits = (_dec = primitiveTrait({
  name: "Identifier",
  type: "string",
  description: "A string that identifies the property when communicating with the server."
}), _dec2 = primitiveTrait({
  name: "Title",
  type: "string",
  description: "A display title."
}), _dec3 = primitiveTrait({
  name: "Units",
  type: "string",
  description: "The unit of the property value"
}), _dec4 = primitiveTrait({
  name: "Default duration",
  type: "string",
  description: "The intervals between observations. eg: 10d - Final character must be s, h, d or y for seconds, hours, days or years."
}), _class = class ObservablePropertyTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "identifier", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "units", _descriptor3, this);
    _initializerDefineProperty(this, "defaultDuration", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "identifier", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "units", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "defaultDuration", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export class ProcedureTraits extends mixTraits(ObservablePropertyTraits) {}
let SensorObservationCatalogItemTraits = (_dec5 = primitiveTrait({
  name: "Request size limit",
  type: "number",
  description: "Gets or sets the maximum number of timeseries to request of the server in a single GetObservation request. Servers may have a Response Size Limit, eg. 250. Note the number of responses may be different to the number requested, eg. the BoM server can return > 1 timeseries/feature identifier, (such as ...stations/41001702), so it can be sensible to set this below the response size limit."
}), _dec6 = primitiveTrait({
  name: "Request number limit",
  type: "number",
  description: "Gets or sets the maximum number of GetObservation requests that we can fire off at a time. If the response size limit is 250, and this is 4, then observations for at most 1000 features will load. If there are more than 1000 features, they will be shown without observation data, until they are clicked."
}), _dec7 = primitiveTrait({
  name: "Request template",
  type: "string",
  description: "The template XML string to POST to the SOS server to query for GetObservation. If this property is undefined, `SensorObservationServiceCatalogItem.defaultRequestTemplate` is used. This is used as a Mustache template. See SensorObservationServiceRequestTemplate.xml for the default. Be careful with newlines inside tags: Mustache can add an extra space in the front of them, which causes the request to fail on the SOS server."
}), _dec8 = objectArrayTrait({
  name: "Observable properties",
  type: ObservablePropertyTraits,
  idProperty: "identifier",
  description: "The sensor observation service observableProperties that the user can choose from for this catalog item."
}), _dec9 = primitiveTrait({
  name: "Filter by procedure",
  type: "boolean",
  description: "Whether to include the list of procedures in GetFeatureOfInterest calls, so that only locations that support those procedures are returned. For some servers (such as BoM's Water Data Online), this causes the request to time out."
}), _dec0 = objectArrayTrait({
  name: "Procedures",
  type: ProcedureTraits,
  idProperty: "identifier",
  description: "The sensor observation service procedures that the user can choose from for this catalog item."
}), _dec1 = primitiveTrait({
  name: "Procedures name",
  type: "string",
  description: "Gets or sets the name seen by the user for the list of procedures. Defaults to `Procedure`, but eg. for BoM, `Frequency` would be better."
}), _dec10 = primitiveTrait({
  name: "Observable properties name",
  type: "string",
  description: "Gets or sets the name seen by the user for the list of observable properties. Defaults to `Property`, but eg. for BoM, `Observation type` would be better."
}), _dec11 = primitiveArrayTrait({
  name: "Station ID whitelist",
  type: "string",
  description: "If set, an array of IDs. Only station IDs that match these will be included."
}), _dec12 = primitiveArrayTrait({
  name: "Station ID blacklist",
  type: "string",
  description: "If set, an array of IDs. Only station IDs that match these will be included."
}), _dec13 = primitiveTrait({
  name: "Start date",
  type: "string",
  description: "An start date in ISO8601 format. All requests filter to this start date. Set to undefined for no temporal filter."
}), _dec14 = primitiveTrait({
  name: "End date",
  type: "string",
  description: "An end date in ISO8601 format. All requests filter to this end date. Set to undefined to use the current date."
}), _dec15 = primitiveTrait({
  name: "Show as chart",
  type: "boolean",
  description: "When `true`, loads the observation data for charts instead of feature points data to plot on map"
}), _dec16 = primitiveTrait({
  name: "Chart feature of interest identifier",
  type: "string",
  description: "The `identifier` of the feature-of-interest for which we are showing the chart."
}), _dec17 = primitiveTrait({
  name: "Selected observable id",
  type: "string",
  description: "The identifier of the selected observable property"
}), _class2 = class SensorObservationCatalogItemTraits extends mixTraits(TableTraits, UrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "requestSizeLimit", _descriptor5, this);
    _initializerDefineProperty(this, "requestNumberLimit", _descriptor6, this);
    _initializerDefineProperty(this, "requestTemplate", _descriptor7, this);
    _initializerDefineProperty(this, "observableProperties", _descriptor8, this);
    _initializerDefineProperty(this, "filterByProcedures", _descriptor9, this);
    _initializerDefineProperty(this, "procedures", _descriptor0, this);
    _initializerDefineProperty(this, "proceduresName", _descriptor1, this);
    _initializerDefineProperty(this, "observablePropertiesName", _descriptor10, this);
    _initializerDefineProperty(this, "stationIdWhitelist", _descriptor11, this);
    _initializerDefineProperty(this, "stationIdBlacklist", _descriptor12, this);
    _initializerDefineProperty(this, "startDate", _descriptor13, this);
    _initializerDefineProperty(this, "endDate", _descriptor14, this);
    _initializerDefineProperty(this, "showAsChart", _descriptor15, this);
    _initializerDefineProperty(this, "chartFeatureOfInterestIdentifier", _descriptor16, this);
  }
  get selectedObservableId() {
    return;
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "requestSizeLimit", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 200;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "requestNumberLimit", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 3;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "requestTemplate", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "observableProperties", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "filterByProcedures", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "procedures", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "proceduresName", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return i18next.t("models.sensorObservationService.procedure");
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "observablePropertiesName", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return i18next.t("models.sensorObservationService.property");
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "stationIdWhitelist", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "stationIdBlacklist", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "startDate", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "endDate", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "showAsChart", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "chartFeatureOfInterestIdentifier", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "selectedObservableId", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedObservableId"), _class2.prototype), _class2);
export { SensorObservationCatalogItemTraits as default };